import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Skeleton from 'react-loading-skeleton'


const Installation = ({ settingInfo, loading }) => {

    /**
     * Used for render the UI on home page
     */
  return (
    <section dir="ltr" className="Installation_sec">

      <Container>
        <Row>
          <Col lg={5} md={6} sm={12}>
            <div className="heading_Common_toall position-relative text-start pt-lg-5">

              {
                loading ? <Skeleton width={"80%"} height={26} /> :
                  <h2 className="heading_common mb-3 text-start w-auto">
                    {settingInfo?.heading3}
                  </h2>
              }
              {
                loading ? <Skeleton width={"80%"} height={26} /> :
                  <p>
                    {settingInfo?.description}
                  </p>
              }


            </div>
          </Col>

          <Col lg={7} md={6} sm={12}>
            <div className="installation_img position-relative">
              <div className="gradient_div"></div>
              {
                loading ? <Skeleton width={"80%"} height={26} /> : <img src={settingInfo?.image} alt="" className="img-fluid" />}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Installation;
